import { ButtonSubLogic as ButtonSub } from './ButtonSub.logic'
import ButtonSubView from './ButtonSub.view'

export default ButtonSub
export { ButtonSubView }
